import { scheduleOrderReport } from '@gtpl/shared-models/sale-management'
import { SaleOrderService } from '@gtpl/shared-services/sale-management'
import { Button, Card, Col, Form, Row, Select } from 'antd'
import React, { useEffect, useState  } from 'react'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Space } from 'antd';

const OrderBookScheduleReport = () => {
    const saleService=new SaleOrderService()
    const [gradesData,setGradesData]=useState<any>()
    const [productsData,setProductsData]=useState<any>()
    const {Option}=Select
    const [form] = Form.useForm();
    

    useEffect(()=>{
        // getDataForScheduleorderReport() 
        getProductDropdownForScheduleorderReport()
    },[])

    const getProductDropdownForScheduleorderReport = () => {
        saleService.getProductDropdownForScheduleorderReport().then((res) => {
          if (res.status) {
            setProductsData(res.data);
          }
        });
      };

    const getDataForScheduleorderReport = () => {
      const date = new Date();
      const formattedDate = date.toISOString().split('T')[0]; 
      const req=new scheduleOrderReport(form.getFieldValue('product'),formattedDate)
        saleService.getDataForScheduleorderReport(req).then((res) => {
          if (res.status) {
            setGradesData(res.data);
          }
        });
      };

      const onReset = () => {
        form.resetFields();
      };
     
  return (
    <div>
        <Card title={<span style={{ color: 'white' }} > Order Schedule Report</span>}
                    style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
                     extra = {
                            <ReactHTMLTableToExcel
                            id='excel-button'
                            className="ant-btn ant-btn-primary"
                            table='report-table'
                            filename='order-book-schedule-report'
                            sheet="order-book-schedule-report"
                            buttonText='Get Excel'
                      
                                  />
                                 }  >
            <Form form={form} onFinish={getDataForScheduleorderReport}>
                <Row gutter={24}>
                    <Col span={6}>
                    <Form.Item name="product" label="Product" >
                            <Select
                                placeholder="Select Product"
                                showSearch
                                optionFilterProp="children" 
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
                            >
                                {productsData?.map(dropData => {
                                    return <Option key={dropData.skuCodeId} value={dropData.shortCode}>{dropData.shortCode}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                    <Space>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Get Report
                        </Button>
                      </Form.Item>

                      <Form.Item>
                        <Button type="primary" onClick={onReset}>
                          Reset
                        </Button>
                      </Form.Item>
                    </Space>
                  </Col>
                </Row>
            </Form>
            
        {gradesData && gradesData.map((group: any, index: number) => {

  const monthMap: { [abbr: string]: number } = {
    JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5,
    JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11,
  };
  
  const uniqueMonths = Array.from(new Set(
    group?.data?.flatMap((item: any) =>
      item?.cartonsData?.map((cd: any) => cd.date)
    )
  )).sort((a: string, b: string) => {
    const [monthA, yearA] = a?.split("'");
    const [monthB, yearB] = b?.split("'");
    const dateA = new Date(2000 + parseInt(yearA), monthMap[monthA]);
    const dateB = new Date(2000 + parseInt(yearB), monthMap[monthB]);
    return dateA?.getTime() - dateB?.getTime();
  });
  

  const casesMap: { [grade: string]: { [month: string]: string } } = {};
  const containerMap: { [grade: string]: { [month: string]: string } } = {};
  const gradeTotalMap: { [grade: string]: number } = {};
  const gradeContainerTotalMap: { [grade: string]: number } = {};

  let overallTotal = 0;
  let overallContainerTotal = 0;

  group.data?.forEach((item: any) => {
    casesMap[item.grade] = {};
    containerMap[item.grade] = {};
    let containerSum = 0;

    item.cartonsData?.forEach((cd: any) => {
      casesMap[item.grade][cd.date] = cd.cases;
      containerMap[item.grade][cd.date] = cd.containers;
      containerSum += parseFloat(cd.containers || '0');
    });

    gradeTotalMap[item.grade] = item.totalCases;
    overallTotal += item.totalCases;
    gradeContainerTotalMap[item.grade] = containerSum;
    overallContainerTotal += containerSum;
  });

  
  return (
    <table id='report-table'
      key={index}
      style={{ borderCollapse: 'collapse', width: '100%', marginBottom: '20px' }}
    >
      <thead>
        <tr>
          <th
            colSpan={group.data.length * 2 + 3}
            style={{
              textAlign: 'center',
              fontSize: '18px',
              border: '1px solid black',
              fontWeight: 'bold',
              backgroundColor: 'lightblue'
            }}
          >
            {group?.shortCode}
          </th>
        </tr>
        <tr>
          <th
            colSpan={group.data.length * 2 + 3}
            style={{
              textAlign: 'center',
              fontSize: '18px',
              border: '1px solid black',
              fontWeight: 'bold',
              backgroundColor: 'lightblue'
            }}
          >
            SHIPMENT SCHEDULES & VACANT SLOTS AVAILABLE FOR ORDERS
          </th>
        </tr>
        {/* HON Row */}
        <tr>
          <th style={{ border: '1px solid black', textAlign: 'center' }}>HON</th>
          {group.data.map((item: any, idx: number) => (
            <th key={idx} colSpan={2} style={{ border: '1px solid black', textAlign: 'center' }}>
              {item.count}
            </th>
          ))}
          <th style={{ border: '1px solid black', textAlign: 'center' }}></th>
          <th style={{ border: '1px solid black', textAlign: 'center' }}></th>
        </tr>
        {/* SHIPMENT MONTH Header */}
        <tr>
          <th style={{ border: '1px solid black', textAlign: 'center' }}>SHIPMENT MONTH</th>
          {group.data.map((item: any, idx: number) => (
            <React.Fragment key={idx}>
              <th colSpan={2} style={{ border: '1px solid black', textAlign: 'center' }}>
                {item.grade}
              </th>
            </React.Fragment>
          ))}
          <th style={{ border: '1px solid black', textAlign: 'center' }}></th>
          <th style={{ border: '1px solid black', textAlign: 'center' }}></th>
        </tr>
        {/* Cartons/Containers Row */}
        <tr>
          <th style={{ border: '1px solid black', textAlign: 'center' }}></th>
          {group.data.map((item: any, idx: number) => (
            <React.Fragment key={idx}>
              <th style={{ border: '1px solid black', textAlign: 'center' }}>Cartons</th>
              <th style={{ border: '1px solid black', textAlign: 'center' }}>Containers</th>
            </React.Fragment>
          ))}
          <th style={{ border: '1px solid black', textAlign: 'center',backgroundColor: 'lightblue' }}>Cartons Total</th>
          <th style={{ border: '1px solid black', textAlign: 'center',backgroundColor: 'lightblue' }}>Containers Total</th>
        </tr>
      </thead>
  
      {/* Data Rows */}
      <tbody>
        {uniqueMonths.map((month, monthIdx) => {
          let grandTotal = 0;
          let grandTotalContainers = 0;
          return (
            <tr key={monthIdx}>
              <td style={{ border: '1px solid black', textAlign: 'center' }}>{month}</td>
              {group.data?.map((item: any, gradeIdx: number) => {
                const grade = item.grade as string;
                const cases = casesMap[grade]?.[month as string] || '-';
                const containers = containerMap[grade]?.[month as string] || '-';
                grandTotal += parseInt(cases !== '-' ? cases : '0', 10);
                grandTotalContainers += parseFloat(containers !== '-' ? containers : '0');
                return (
                  <React.Fragment key={gradeIdx}>
                    <td style={{ border: '1px solid black', textAlign: 'center' }}>{cases}</td>
                    <td style={{ border: '1px solid black', textAlign: 'center' }}>{containers}</td>
                  </React.Fragment>
                );
              })}
              <td style={{ border: '1px solid black', textAlign: 'center',backgroundColor: '#f4f1c8' }}>{grandTotal}</td>
              <td style={{ border: '1px solid black', textAlign: 'center',backgroundColor: '#f4f1c8' }}>{grandTotalContainers.toFixed(2)}</td>
            </tr>
          );
        })}
      </tbody>
  
      {/* Totals */}
      <tfoot>
        <tr>
          <td style={{ border: '1px solid black', textAlign: 'center', fontWeight: 'bold' }}>
            Total
          </td>
          {group.data.map((item: any, idx: number) => (
            <React.Fragment key={idx}>
              <td style={{ border: '1px solid black', textAlign: 'center', fontWeight: 'bold' }}>
                {gradeTotalMap[item.grade]}
              </td>
              <td style={{ border: '1px solid black', textAlign: 'center', fontWeight: 'bold' }}>
                {gradeContainerTotalMap[item.grade]?.toFixed(2) || '0.00'}
              </td>
            </React.Fragment>
          ))}
          <td style={{ border: '1px solid black', textAlign: 'center', fontWeight: 'bold' }}>
            {overallTotal}
          </td>
          <td style={{ border: '1px solid black', textAlign: 'center', fontWeight: 'bold' }}>
            {overallContainerTotal.toFixed(2)}
          </td>
        </tr>
      </tfoot>
    </table>
  );
  
})}

        </Card>
    </div>
  )
}

export default OrderBookScheduleReport